import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Contact() {
  const [dark, setDark] = useState(true);
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const API_URL = `https://api.mogym.ir`;
  const navigate = useNavigate();

  const handleSubmit = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    if (!name || !message) {
      setError('لطفاً تمام فیلدها را پر کنید.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const res = await fetch(`${API_URL}/api/contact-us`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ name, message })
      });

      if (!res.ok) throw new Error('خطا در ارسال پیام');

      setSuccess('✅ پیام شما با موفقیت ارسال شد.');
      setName('');
      setMessage('');
    } catch {
      setError('❌ ارسال پیام با خطا مواجه شد.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white max-w-2xl mx-auto px-4 py-10 font-vazir">
      <h1 className="text-2xl font-bold mb-6 text-center">📬 تماس با ما</h1>

      <div className="bg-gray-100 dark:bg-[#1f1f2f] p-5 rounded-xl mb-8 text-sm">
        <p className="mb-2">📍 آدرس: تهران، خیابان آزادی، پلاک ۲۴۲، طبقه دوم</p>
        <p className="mb-2">📱 پشتیبانی واتساپ: <a href="https://wa.me/989031239853" target="_blank" rel="noreferrer" className="text-blue-500">ارسال پیام در واتساپ</a></p>
        <p className="text-gray-500 dark:text-gray-400">ساعات پاسخگویی: ۹ صبح تا ۵ عصر</p>
      </div>

      <div className="space-y-4">
        <input
          type="text"
          placeholder="نام شما"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full p-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#2a2f3b]"
        />
        <textarea
          placeholder="پیام شما..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={6}
          className="w-full p-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#2a2f3b]"
        ></textarea>

        {error && <p className="text-red-500 text-sm">{error}</p>}
        {success && <p className="text-green-500 text-sm">{success}</p>}

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-xl disabled:opacity-50"
        >
          {loading ? 'در حال ارسال...' : 'ارسال پیام'}
        </button>
      </div>
            <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? '☀️' : '🌙'}
        </button>
      </div>
    </div>
  );
}
